//CSS
import './style.scss'
//imagesloaded
import imagesLoaded from 'imagesloaded'
//swiper
import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'
//GSAP
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)
//lottie
import lottie from 'lottie-web'
//svgアニメーションのjsonデータ
import merit from './merit.json'
import recommend from './recommend.json'
import contact from './contact.json'
import contact_sp from './contact.json' //SP用二つ目
import artist from './artist.json'
import works from './works.json'
import voice from './voice.json'
import flow from './flow.json'
import contact_title from './contact_form.json'

document.addEventListener('DOMContentLoaded', () => {
  //ローディング
  const loadingDom = document.getElementById('loading')
  const loadingLogo = document.getElementById('loading-logo')
  loadingLogo.classList.add('fade-in')
  setTimeout(() => {
    loadingDom.classList.add('fade-out')
    setTimeout(() => {
      loadingDom.style.display = 'none'

      imagesLoaded(document.getElementById('main'), () => {
        //スライド起動
        swiperInit()
        // btnInit()
        currentTriggers = btnInit()
        anchorInit()
        document.getElementById('img-01').classList.add('in')
        setTimeout(() => {
          document.getElementById('img-02').classList.add('in')
        }, 500)
        setTimeout(() => {
          document.getElementById('img-03').classList.add('in')
        }, 1000)
        setTimeout(() => {
          document.getElementById('balloon').classList.add('in')
        }, 1500)
      })
    }, 1000)
  }, 2000)
})

//ふわふわボタンの表示・非表示
const btnInit = () => {
  // 画面幅での判定
  const isMobile = window.innerWidth <= 640
  const btnDown = document.getElementById('btn-down')
  const triggers = []

  // PC表示時は初期表示を設定
  if (!isMobile) {
    btnDown.classList.remove('hidden')
    gsap.set('#btn-down', { opacity: 1, y: 0 })
  } else {
    // スマートフォン表示時は初期非表示
    btnDown.classList.add('hidden')
    gsap.set('#btn-down', { opacity: 0, y: 500 })
  }
  btnDown.classList.remove('invisible')

  // スマートフォン用の追加トリガー
  if (isMobile) {
    const meritTrigger = ScrollTrigger.create({
      trigger: '#merit',
      start: 'top 100%',
      onEnter: () => {
        gsap.to('#btn-down', {
          opacity: 1,
          y: 0,
          duration: 0.8,
          display: 'block',
        })
        btnDown.classList.remove('hidden')
      },
      onLeaveBack: () => {
        gsap.to('#btn-down', {
          opacity: 0,
          y: 500,
          duration: 0.8,
        })
        setTimeout(() => {
          btnDown.classList.add('hidden')
        }, 1000)
      },
    })
    triggers.push(meritTrigger)
  }

  // コンタクトフォーム付近での表示制御
  const contactTrigger = ScrollTrigger.create({
    trigger: '#contact-form',
    start: 'top 80%',
    end: 'bottom 20%',
    onEnter: () => {
      gsap.to('#btn-down', {
        opacity: 0,
        y: 500,
        duration: 0.8,
      })
      setTimeout(() => {
        btnDown.classList.add('hidden')
      }, 1000)
    },
    onLeaveBack: () => {
      // スマートフォンの場合は、merit要素を超えているかチェック
      if (isMobile) {
        const meritTop = document
          .getElementById('merit')
          .getBoundingClientRect().top
        if (meritTop > 0) return // merit要素を超えていない場合は表示しない
      }

      gsap.to('#btn-down', {
        opacity: 1,
        y: 0,
        duration: 0.8,
        display: 'block',
      })
      btnDown.classList.remove('hidden')
    },
  })
  triggers.push(contactTrigger)
  return triggers
}

// 現在のトリガーを保持する変数
let currentTriggers = []

// リサイズ時に再初期化
window.addEventListener('resize', () => {
  setTimeout(() => {
    // 現在のトリガーだけをkill
    currentTriggers.forEach((trigger) => trigger.kill())
    // 新しいトリガーを設定
    currentTriggers = btnInit()
  }, 250)
})

function anchorInit() {
  //アンカークリック
  const anchors = document.querySelectorAll('.anchor')
  anchors.forEach((elm) => {
    elm.addEventListener('click', (event) => {
      let targetId = elm.getAttribute('href')
      window.scrollTo({
        top: document.querySelector(targetId).offsetTop,
        left: 0,
        behavior: 'smooth',
      })
      event.preventDefault()
    })
  })
}

const swiperInit = () => {
  new Swiper('#works-carousel', {
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 1600,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1500: {
        slidesPerView: 3,
      },
    },
    navigation: {
      nextEl: '#btn-next',
      prevEl: '#btn-prev',
    },
    on: {
      init: function () {
        gsapInit()
      },
    },
  })
}

//GSAP
function gsapInit() {
  //lottie
  const animationData = {
    merit: merit,
    recommend: recommend,
    contact: contact,
    contact_sp: contact_sp,
    artist: artist,
    works: works,
    voice: voice,
    flow: flow,
    contact_title: contact_title,
  }
  const lottieObjs = {}
  gsap.utils.toArray('.gs-fig').forEach(function (elem) {
    lottieObjs[elem.id] = lottie.loadAnimation({
      container: elem,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData: animationData[elem.id],
      rendererSettings: {
        id: elem.id,
      },
    })
    lottieObjs[elem.id].setSpeed(1.5)
    ScrollTrigger.create({
      trigger: elem,
      once: true,
      start: 'top 95%',
      delay: elem.getAttribute('data-delay'),
      toggleActions: 'play none none none',
      onEnter: function () {
        lottieObjs[elem.id].play()
      },
      markers: false,
    })
  })
}
